<template>
    <div class="alert alert-success fade show text-center">
        <strong>You are logged into <span style="color: black">{{supervisor.supervisorName}}'s account</span> (<small style="color: black">{{supervisor.supervisorEmail}}</small>)</strong>
        <a href="/dashboard" v-if="showExitBtn" class="pull-right text-white">
          <b>Exit Collaboration</b>
        </a>
    </div>
</template>

<script>
    export default {
        name: "OwnerInformationBanner",
        props: {
            supervisor: {
                required: true,
                type: Object
            },
            showExitBtn: {
                required: false,
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
